import React from 'react';

const Pagination = ({ 
  currentPage, 
  setCurrentPage, 
  totalPages = 1, 
  hasMoreRecords = false, 
  isCursorPagination = false,
  onLastPage,
}) => {
  // Shared button styles to keep code DRY (Don't Repeat Yourself)
  const btnClass = "rounded-lg border border-blue-500/30 bg-blue-500/10 px-3 py-2 text-xs font-medium text-slate-300 transition-all duration-200 hover:border-blue-500/50 hover:bg-blue-500/20 disabled:cursor-not-allowed disabled:opacity-40 sm:px-4 sm:text-sm";
  const activeDisplay = "rounded-lg border border-blue-500/30 bg-blue-500/15 px-4 py-2 text-xs font-semibold text-white sm:px-5 sm:text-sm";

  return (
    <div className="mt-6 flex flex-wrap items-center justify-center gap-2 rounded-xl border border-slate-700/30 bg-slate-800/30 p-4 sm:gap-3 sm:p-5">
      {/* First Button */}
      <button
        onClick={() => setCurrentPage(1)}
        disabled={currentPage === 1}
        className={btnClass}
      >
        First
      </button>

      {/* Previous Button */}
      <button
        onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
        disabled={currentPage === 1}
        className={btnClass}
      >
        Previous
      </button>

      {/* Page Display */}
      <span className={activeDisplay}>
        Page {currentPage} {!isCursorPagination && `of ${Math.max(totalPages, 1)}`}
      </span>

      {/* Next Button */}
      <button
        onClick={() => setCurrentPage((prev) => prev + 1)}
        disabled={isCursorPagination ? !hasMoreRecords : currentPage >= Math.max(totalPages, 1)}
        className={btnClass}
      >
        Next
      </button>

      {/* Last Button */}
      {!isCursorPagination || onLastPage ? (
        <button
          onClick={() => {
            if (onLastPage) {
              onLastPage();
              return;
            }

            setCurrentPage(Math.max(totalPages, 1));
          }}
          disabled={currentPage >= Math.max(totalPages, 1)}
          className={btnClass}
        >
          Last
        </button>
      ) : null}

      {/* Cursor Pagination Status */}
      {isCursorPagination ? (
        <span className="w-full text-center text-xs font-medium text-slate-400 sm:w-auto ml-2">
          {hasMoreRecords ? 'More available' : 'End of results'}
        </span>
      ) : null}
    </div>
  );
};

export default Pagination;
